import { render, staticRenderFns } from "./NonInvestedFundCards.vue?vue&type=template&id=ed01d7e4&scoped=true"
import script from "./NonInvestedFundCards.vue?vue&type=script&lang=js"
export * from "./NonInvestedFundCards.vue?vue&type=script&lang=js"
import style0 from "./NonInvestedFundCards.vue?vue&type=style&index=0&id=ed01d7e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed01d7e4",
  null
  
)

export default component.exports